// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from '../../fonts/iconoon.scss';

type Props = {
    name: string,
    color: string,
    size: string | number,
    style: Object,
    className: string,
}

class Icon extends Component<Object> {
    render() {
        const iconName = 'iconoon-' + this.props.name;
        if (!styles[iconName]) {
            return null;
        }

        if (this.props.className) {
            return <i className={[styles.iconoon, styles[iconName], this.props.className].join(' ')} />;
        }

        const size = this.props.size + 'px' || '14px';
        const color = this.props.color || '';
        const style = {
            color: color,
            fontSize: size,
        };
        return (
            <i
                className={
                    styles.iconoon + ' ' + styles[iconName] + (this.props.className ? ' ' + this.props.className : '')
                }
                style={{ ...style, ...this.props.style }}
            />
        );
    }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/components/common/Icon.js